import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../util/Rest';
import {UNSUBSCRIBE, SEARCH_BY} from '../../constants/Lookup';

const initialData = {
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'spouse',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchDropDownData, fetchStart, fetchError} = slice.actions;

export const fetchTextHistory = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [UNSUBSCRIBE, SEARCH_BY],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
